import { useEffect, useRef, useState } from "react";

// Returns [ref, inView]. Fires once when the element scrolls into view so we
// can lazy-load each card's intraday chart instead of all at once.
export default function useInView(rootMargin = "120px") {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || inView) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [inView, rootMargin]);

  return [ref, inView];
}
